import { render, staticRenderFns } from "./Item_IV.vue?vue&type=template&id=5c3b085a&scoped=true"
import script from "./Item_IV.vue?vue&type=script&lang=js"
export * from "./Item_IV.vue?vue&type=script&lang=js"
import style0 from "./Item_IV.vue?vue&type=style&index=0&id=5c3b085a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3b085a",
  null
  
)

export default component.exports